import { downloadFile } from "@/utils/fileHelper";

export const downloadMixin = {
  methods: {
    downloadDocument(doc) {
      this.$store.commit('IS_LOADING', true);
      this.$axios
        .get('/espaceBibliotheque/document/download/' + doc.id, { responseType: 'arraybuffer' })
        .then((response) => {
          this.$store.commit('IS_LOADING', false);
          downloadFile(response, doc.nom_fichier, doc.extension);
        })
        .catch((error) => {
          this.$store.commit('IS_LOADING', false);
          this.$swal({
            position: 'top', type: 'error', title: 'Attention !!',
            text: 'Une erreur est survenue...', showConfirmButton: false, timer: 5000
          });
        });
    }
  }
}
